'use client'

import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import styles from "./ua.module.scss";
import { DMForm, DMTradeForm } from "@dealermesh/react";

const Form = forwardRef((props, ref) => {

  const formRef = useRef()
  
  if (!props.form && !props.id && process.env.NODE_ENV == 'development') {
    console.log("******* SEO WARNING! Form: NO ID SPECIFIED!!!!", { children: props.children });
  }
  if (!props.form && !props.name && process.env.NODE_ENV == 'development') {
    console.log("******* SEO WARNING! Form: NO NAME SPECIFIED!!!!", { children: props.children });
  }

  /**
   * 
   * @param {*} fn 
   * @param {*} params - String or JSON
   */
  const call = (fn, ...args) => {
    if (typeof args == 'object') {
      eval("formRef.current." + fn + "(...args)")
    } else {
      eval("formRef.current." + fn + "('" + args + "')")
    }
  }
  
  useImperativeHandle(ref, () => ({
    call
  }))
  
  if (props.form == 'trade') {
    return <div className={ styles.form + ' ' + (props.theme ? styles[props.theme] : '') + ' ' + (props.className || '')} style={ props.style || {}}>
      <DMTradeForm ref={formRef} {...props} className={ styles.form + ' ' + props.className } style={ props.style || {}} onFormSubmit={props.onFormSubmit}>{ props.children }</DMTradeForm>
    </div>
  }
  
  return <DMForm {...props} className={ styles.form + ' ' + (props.theme ? styles[props.theme] : '') + ' ' + (props.className || '') }>
    { props.children }
  </DMForm>
  
})

Form.displayName = 'Form';
export default Form